import { Assert } from "../Utils/Assert";

export class RouteHelper {
    public static insertRouteParameters(route: string, parameters: any): string {
        const regEx = /:\w+/g;
        const matches = route.match(regEx);
        if (!matches || matches.length < 1) {
            return route;
        }

        const matchesCount = matches.length;
        for (let i = 0; i < matchesCount; i++) {
            route = this.replaceRouteParameter(route, matches[i], parameters);
        }

        return route;
    }

    public static toLowerCaseExceptParameters(route: string): string {
        const paramRegEx = /:\w+/g;
        const matches = route.match(paramRegEx);
        let result = route.toLowerCase();

        if (matches) {
            matches.forEach((match) => {
                const ignoreCaseRegex = new RegExp(match, "ig");
                result = result.replace(ignoreCaseRegex, match);
            });
        }

        return result;
    }

    private static replaceRouteParameter(route: string, parameter: string, parametersObject: any): string {
        const parameterName = parameter.trim().substr(1); // remove leading ':'
        const paramValue = parametersObject[parameterName];
        Assert(
            paramValue,
            "RouteHelper.insertRouteParameters: could not get parameter " +
                parameterName +
                " from parameters for route " +
                route
        );
        return route.replace(parameter, paramValue);
    }
}
